import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import {
    GetNewsSearchGQL,
    GetUnitiesGQL,
    GetNewsSearchQuery,
    Unity,
    News,
    User,
    RemoveNewsGQL, NewsPage
} from '../../../generated/graphql';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import {QueryRef} from 'apollo-angular';
import {UserService} from "../../service/user.service";
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

const FILTER_KEY = 'filterClicNews';

@Component({
    selector: 'app-clic-news',
    templateUrl: './clic-news.component.html',
    styleUrls: ['./clic-news.component.scss']
})
export class ClicNewsComponent extends BaseComponent implements OnInit, OnDestroy {
    user: User = new User();
    getNewsSearchQuery: QueryRef<GetNewsSearchQuery>;
    news: NewsPage = new NewsPage() // News[] = [];
    modelFilterKeyword = '';
    modelFilterStatus = '';
    language = 'pt';
    page = 1;
    private destroy$ = new Subject<void>();

    newClicNews: boolean;
    editClicNews: boolean;
    deleteClicNews: boolean;

    constructor(
        public router: Router,
        public loading: NgxSpinnerService,
        public translate: TranslateService,
        public getNewsSearchGQL: GetNewsSearchGQL,
        public removeNewsGQL: RemoveNewsGQL,
        public userService: UserService
    ) {
        super(router, loading, translate);
    }

    ngOnInit(): void {
        // restaura busca, status e página salvos (ao voltar do detalhe) antes da primeira query
        const restored = this.restoreFilter();
        let firstEmission = true;

        this.userService.user.pipe(takeUntil(this.destroy$)).subscribe({
            next: data => {
                this.user = data as User;
                this.userProfile();
            }, error: err => super.onError(err)
        });
        // language é um BehaviorSubject: a 1ª emissão (imediata) usa a página restaurada;
        // trocas de idioma posteriores voltam para a página 1
        this.userService.language.pipe(takeUntil(this.destroy$)).subscribe({
            next: data => {
                this.language = this.isNullOrUndefined(data) ? this.translate.currentLang : data;
                if (!(firstEmission && restored)) {
                    this.page = 1;
                    this.saveFilter();
                }
                firstEmission = false;
                this.getNewsSearch();
            }, error: err => super.onError(err)
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    pageChanged(event) {
        this.page = event;
        this.saveFilter();
        this.getNewsSearch();
    }

    private saveFilter() {
        super.setFilterLocal(FILTER_KEY, {
            keyword: this.modelFilterKeyword,
            status: this.modelFilterStatus,
            page: this.page,
        });
    }

    private restoreFilter(): boolean {
        const localFilter = super.getFilterLocal(FILTER_KEY);
        if (this.isNullOrUndefined(localFilter)) {
            return false;
        }
        const el = JSON.parse(localFilter);
        this.modelFilterKeyword = el.keyword ?? '';
        this.modelFilterStatus = el.status ?? '';
        this.page = el.page || 1;
        return true;
    }

    actionSearch() {
        // nova busca volta para a página 1
        this.page = 1;
        this.saveFilter();
        this.getNewsSearchQuery.refetch({
            page: this.page,
            input: this.modelFilterKeyword,
            status: this.modelFilterStatus,
            language: this.language === 'es' ? 'es-ES' : 'pt-BR'
        });
    }

    getNewsSearch() {
        this.getNewsSearchQuery = this.getNewsSearchGQL.watch({
            page: this.page,
            input: this.modelFilterKeyword,
            status: this.modelFilterStatus,
            language: this.language === 'es' ? 'es-ES' : 'pt-BR'
        });
        this.getNewsSearchQuery.valueChanges.subscribe(({data}) => {
            this.news = data.getNewsSearch as NewsPage;
        });
    }

    removeNews(id) {
        super.confirmMessage(this.translate.instant('baseComponent.warningAttention'), 'Deseja realmente deletar essa notícia?', () => {
            this.loading.show();
            this.removeNewsGQL.mutate({input: id}).subscribe(({data}) => {
                this.getNewsSearchQuery.refetch({
                    input: this.modelFilterKeyword,
                    status: this.modelFilterStatus,
                    language: this.language === 'es' ? 'es-ES' : 'pt-BR'
                });
                this.showMessage('Sucesso', `Notícia removida com sucesso!`, 'success');
                this.loading.hide();

            });
        });
    }

    userProfile() {
        switch (this.user.role) {
            case 'admin':
                this.newClicNews = true;
                this.editClicNews = true;
                this.deleteClicNews = true;
                break;
            case 'user':
                this.newClicNews = true;
                this.editClicNews = true;
                this.deleteClicNews = true;
                break;
            case 'corporate-manager':
                this.newClicNews = true;
                this.editClicNews = true;
                this.deleteClicNews = true;
                break;
            case 'local-manager':
                this.newClicNews = true;
                this.editClicNews = true;
                this.deleteClicNews = false;
                break;
            case 'committee-member':
                this.newClicNews = false;
                this.editClicNews = false;
                this.deleteClicNews = false;
                break;

        }
    }
}
